import { render } from "./newComponent.vue?vue&type=template&id=6506f518"
import script from "./newComponent.vue?vue&type=script&lang=js"
export * from "./newComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__